import { render } from "./AccountSummary.vue?vue&type=template&id=0b24d436&scoped=true"
import script from "./AccountSummary.vue?vue&type=script&lang=js"
export * from "./AccountSummary.vue?vue&type=script&lang=js"

import "./AccountSummary.vue?vue&type=style&index=0&id=0b24d436&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b24d436"]])

export default __exports__